
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';
import timePeriodMixins from '~/mixins/timePeriodMixins';

export default {
  name: 'TextLinkAd',
  mixins: [eventTrackingMixins, lgmMixin, timePeriodMixins],
  props: {
    data: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      trackingName: 'textlinkad',
    }
  },
  computed: {
    validItems() {
      return this.data?.filter(item => item?.publishedAt !== null && item?.Link && item?.DisplayText && this.isActivePeriod(item?.TimePeriod));
    }
  },
  methods: {
    handleClick(eventTarget, item) {
      const dataFromClickedElement = this.extractDataFromClickedElement(eventTarget);
      const eventTrackingParams = this.initEventTrackingParams();
      const pageType = this.getPlacementCodeByRouteName();
      const category = `${pageType}_${this.trackingName}`;
      const targetLink = dataFromClickedElement?.href;

      eventTrackingParams.a = item.TrackingParams?.event_action;
      eventTrackingParams.c = category;

      if (this.$isWhatsappLink(targetLink)) {
        eventTrackingParams.a = item.TrackingParams?.event_action || 'open_whatsapp';
        this.$goToURL(targetLink, false, eventTrackingParams, {
          getLGMConversionId: this.getLGMConversionId,
        });
      } else if (this.$isTransitionLink(targetLink)) {
        const data = this.extractDataFromTransitionLink(targetLink)
        eventTrackingParams.a = item.TrackingParams?.event_action || 'click_redirection'
        eventTrackingParams.l = item.DisplayText
        eventTrackingParams.c = `${category}_${data.insurer}_${data.pp_status}_${data.link}`
        eventTrackingParams.cd.insurer_name = `${data.insurer}`
        eventTrackingParams.cd.product_category = `${data.category}`

        this.$goToURL(targetLink, false, eventTrackingParams, {
          getLGMConversionId: this.getLGMConversionId,
          injectLGMConversionId: this.injectLGMConversionId
        });
      } else if (this.$isEComLink(targetLink)) {
        this.$goToURL(targetLink, false, eventTrackingParams, {
          getLGMConversionId: this.getLGMConversionId,
          injectLGMConversionId: this.injectLGMConversionId,
          injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
        });
      } else {
        this.$goToURL(targetLink, false, eventTrackingParams);
      }
      this.sendEventTracking(eventTrackingParams, true);
    },
  }
}
